import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './UserPanel.scss';
import UserPanel from 'components/UserPanel/UserPanel';

const mapStateToProps = (state, ownProps) => {
  const {userDetails = {}} = state;
  const {userDetails: propsUserDetails} = ownProps;
  return {
    ...ownProps,
    userDetails: {
      emailAddress: propsUserDetails?.emailAddress ?? userDetails.workEmail,
      firstName: propsUserDetails?.firstName ?? userDetails.firstName,
      lastName: propsUserDetails?.lastName ?? userDetails.lastName,
      photo: propsUserDetails?.photo ?? userDetails.photo,
    },
  };
};

const mapDispatchToProps = (_) => {
  return {};
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const UserPanelContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserPanel);

export { UserPanelContainer, UserPanel };

UserPanelContainer.propTypes = {
  isUserPrefsDisplayed: PropTypes.bool,
  userDetails: PropTypes.shape({
    emailAddress: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    photo: PropTypes.string,
  }),
  userSettingActions: PropTypes.node,
};
export default UserPanelContainer;